export const combinePackages = (packages = []) => {
  const combined = packages.reduce((acc, pkg) => {
    const { reducers, modals, sagas } = pkg;

    acc.reducers = { ...acc.reducers, ...reducers };
    acc.sagas = { ...acc.sagas, ...sagas };
    acc.modals = { ...acc.modals, ...modals };
    return acc;
  }, {});

  return combined;
};
